export const USERLIST = "admin/user/userList";

export const USERLIST_HARD = "admin/user/hardDeleteUser";

export const USERLIST_EXPORT = "admin/user/exportList";

export const USERLISTPREMIUM = "admin/user/premiumUsers";
export const SUBSCRIPTIONS = "admin/user/subscriptions";

export const USER_DETAILS = "admin/user/detail";

export const LEAD_QUALITY = "admin/user/leadQuality";

export const REMOVE_IMAGES = "admin/user/images"

export const UPDATE_PREMIUM = "admin/user/premium";

export const VIP_PREMIUM = "admin/user/vip";

export const VIP_UNLOCKED = "admin/user/vipUnlocked";

export const FORCE_VERIFICATION = "admin/user/forceFaceVerification";

export const FORCE_ID_VERIFICATION = "admin/user/toggleIdVerification";

export const INTERNAL_USER = "admin/user/internalUsers";

export const INTERNAL_USER_REPLACE_IMAGE = "admin/user/internalUsers/verificationImages";

export const REMOVE_VOICE_NOTE = "/admin/user/voiceNote";
export const UPDATE_BASIC_DETAILS = "admin/user/basicDetails";

export const RECOVER_ACCOUNT_API = "admin/user/recoveAccount";

export const REMOVE_USER_LIST_INTERNAL = "admin/user/replaceFaceVerification/done";

export const HIDE_PROFILE_API = "admin/user/hideProfile";

export const WARNING_IMAGE = "admin/user/photoWarning";

export const BLOCK_USER = "admin/user/userBlockMessage";

export const BLOCK_CONVERSATION_MESSAGE = "admin/user/conversation/userBlockMessage";

export const UPLOAD_VARIFICATION_IMAGE = "admin/user/verificationImage";

export const UPLOAD_PROFILE_IMAGES = "admin/user/image";

export const UPLOAD_VARIFICATION_VOICE = "admin/user/voiceNote";

export const DELETE_CONVERSATION = "admin/user/deleteConversation"

export const DELETE_CONVERSATION_ALL = "admin/user/deleteAllConversation"

export const FAVOURITE_ALL_USERS = "admin/user/favouriteAllUsers"

export const SEND_NOTIFICATION_FEMALE = "admin/user/viewAllProfile";

export const SEND_IMAGE_REQUEST_FEMALE = "admin/user/imageRequests";

export const ACTIVATE_ACCOUNT_API = "admin/user/activate";

export const SUPPORTLIST = "admin/user/supportList";

export const VERIFICATION_LIST = "admin/user/identification";

export const CHANGEE_IMAGE_ORDER = "admin/user/sortProfileImage";

export const FOLLOW_UP = "admin/user/followingUpMessage";

export const REUPLOAD_PROFILE_IMAGE = "admin/user/reuploadProfileImages";

export const VERIFY_MULTIPLE = "admin/user/approveMultipleImages";

export const TOGGLE_AUTO_APPROVE = "admin/user/imageAutoApprove";

export const REFFERAl_LIST = "admin/referral/codes";

export const DISABLE_USER_DEVICE = "admin/user/blockdevice";

export const ENABLE_USER_DEVICE = "admin/user/unblockdevice";

export const REDEEM_LIST = "admin/referral/list";

export const USER_REFERRAL_LIST = "admin/referral/userReferalList";

export const USER_REFERRAL_AMOUNT = "admin/referral/amountPayed";

export const FQA_LIST = "admin/user/faq";

export const FQA_LIST_ORDER = "admin/user/reorderFaq";

export const FQA_CATEGORY_ORDER ="admin/user/reorder/faqCategory"

export const FQA_CATEGORY_LIST = "admin/user/faqCategory";

export const FQA_SUBCATEGORY_LIST = "admin/user/faqSubCategory";

export const WITHDRAWAL_REQUESTS = "admin/user/withdrawalRequests";

export const GRAPH_DATA = "admin/user/stats";

export const GET_OTP_USER = "admin/user/otp";

export const SEND_MESSAGES = "admin/user/sendMessage";

export const SEND_FORCE_UPDATE = "/admin/auth/appVersion";

export const LOCK_IMAGE = "admin/user/imageLock";

export const LOCK_IMAGE_NOTIFICATION = "admin/user/approveImageRequests";

export const REPLACE_FACE_VERIFICATION = "admin/user/replaceFaceVerification";

/////////////post/////////////////

export const POSTS = "admin/user/post";


////////////reports //////////////////////

export const REPORTS_LIST = "admin/user/report";

export const REPORTS_LIST_DETAILS = "admin/user/report/detail";

export const GET_CHAT_MESSAGES = "admin/user/chat";

export const GET_CONVERSATION_LIST = "admin/user/conversations";

export const SINGLE_USER_REPORTS = "admin/user/singleUserReports";

export const GET_IDS_USERS = "admin/user/userList/Ids";

export const VERIFICATION_IMAGES = "admin/user/profile/verificationImages";
